import { TrackedLink } from "@components/analytics/TrackedLink";
import Breadcrumbs from "@components/Breadcrumbs";
import { ImgSrc } from "@config/image";
import { Container, Row, Col } from "react-grid-system";

const GuidesAndTutorials = () => (
  <>
    <Container className="landingGridContainer">
      <Row>
        <Col md={12} lg={8}>
          <Breadcrumbs
            links={[
              { name: "Docs", url: "/docs" },
              { name: "Guides & Tutorials", url: "/guides-and-tutorials" },
            ]}
          />
          <h1>Guides & Tutorials</h1>
          <p>
            Guides & tutorials for learning Blues hardware and cloud services.
          </p>
        </Col>
      </Row>

      <hr />
      <h2>Hands-On Tutorials</h2>

      <Row>
        <Col>
          <div className="landing-page-link-list">
            <div>
              <img alt="" src={ImgSrc("/images/icons/docs/sensors.svg")} />
              <h4>Collecting Sensor Data</h4>
              <p>
                A hands-on tutorial that walks you through collecting sensor
                data and sending it to Notehub.
              </p>
              <TrackedLink
                href="/guides-and-tutorials/collecting-sensor-data"
                className="landingLink"
              >
                Learn more
              </TrackedLink>
            </div>

            <div>
              <img alt="" src={ImgSrc("/images/icons/docs/cloud.svg")} />
              <h4>Routing Data to Cloud</h4>
              <p>
                A hands-on tutorial that guides you through securely forwarding
                your Notehub data to a variety of cloud providers and IoT
                platforms.
              </p>
              <TrackedLink
                href="/guides-and-tutorials/routing-data-to-cloud"
                className="landingLink"
              >
                Learn more
              </TrackedLink>
            </div>

            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/precision-manufacturing.svg")}
              />
              <h4>Building Edge ML Applications</h4>
              <p>
                A hands-on tutorial that walks you through creating an Edge ML
                application, including building your own ML model from scratch.
              </p>
              <TrackedLink
                href="/guides-and-tutorials/building-edge-ml-applications"
                className="landingLink"
              >
                Learn more
              </TrackedLink>
            </div>
          </div>
        </Col>
      </Row>

      <h2>Blues Guides</h2>

      <Row>
        <Col>
          <div className="landing-page-link-list">
            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/send-to-mobile.svg")}
              />
              <h4>Twilio SMS Guide</h4>
              <p>
                Learn how to send SMS messages using Twilio via a Notehub route.
              </p>
              <TrackedLink
                href="/guides-and-tutorials/twilio-sms-guide"
                className="landingLink"
              >
                Learn more
              </TrackedLink>
            </div>

            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/notehub-guides.svg")}
              />
              <h4>Fleet Admin Guide</h4>
              <p>
                Dive into Notehub to discover features that allow you to inspect
                transferred data, manage device fleets, and perform cloud-based
                OTA DFU.
              </p>
              <TrackedLink
                href="/guides-and-tutorials/fleet-admin-guide"
                className="landingLink"
              >
                Learn more
              </TrackedLink>
            </div>

            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/notecard-solutions.svg")}
              />
              <h4>Using the Notehub API</h4>
              <p>
                A tutorial on how to use the Notehub API to manage your
                projects.
              </p>
              <TrackedLink
                href="/guides-and-tutorials/using-the-notehub-api"
                className="landingLink"
              >
                Learn more
              </TrackedLink>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <hr />
          <h2>Notecard Guides</h2>
          <p>
            Guides to help you configure and use the Notecard in your projects.
          </p>

          <div className="gridLinks">
            <h4>In this section</h4>
            <div className="three-column">
              <TrackedLink href="/guides-and-tutorials/notecard-guides/asset-tracking">
                Asset Tracking
              </TrackedLink>
              <TrackedLink href="/guides-and-tutorials/notecard-guides/attention-pin-guide">
                Attention Pin Guide
              </TrackedLink>
              <TrackedLink href="/guides-and-tutorials/notecard-guides/debugging-with-the-ftdi-debug-cable">
                Debugging With the FTDI Debug Cable
              </TrackedLink>
              <TrackedLink href="/guides-and-tutorials/notecard-guides/diagnosing-cellular-connectivity-issues">
                Diagnosing Cellular Connectivity Issues
              </TrackedLink>
              <TrackedLink href="/guides-and-tutorials/notecard-guides/diagnosing-gps-issues">
                Diagnosing GPS Issues
              </TrackedLink>
              <TrackedLink href="/guides-and-tutorials/notecard-guides/encrypting-data-with-the-notecard">
                Encrypting Data With the Notecard
              </TrackedLink>
              <TrackedLink href="/guides-and-tutorials/notecard-guides/minimizing-latency">
                Minimizing Latency
              </TrackedLink>
              <TrackedLink href="/guides-and-tutorials/notecard-guides/notecard-communication-without-a-library">
                Notecard Communication Without a Library
              </TrackedLink>
              <TrackedLink href="/guides-and-tutorials/notecard-guides/notecard-outboard-firmware-update">
                Notecard Outboard Firmware Update
              </TrackedLink>
              <TrackedLink href="/guides-and-tutorials/notecard-guides/remote-command-and-control">
                Remote Command and Control
              </TrackedLink>
              <TrackedLink href="/guides-and-tutorials/notecard-guides/sending-and-receiving-large-binary-objects">
                Sending and Receiving Large Binary Objects
              </TrackedLink>
              <TrackedLink href="/guides-and-tutorials/notecard-guides/serial-over-i2c-protocol">
                Serial-Over-I2C Protocol
              </TrackedLink>
              <TrackedLink href="/guides-and-tutorials/notecard-guides/understanding-environment-variables">
                Understanding Environment Variables
              </TrackedLink>
              <TrackedLink href="/guides-and-tutorials/notecard-guides/understanding-notecard-penalty-boxes">
                Understanding Notecard Penalty Boxes
              </TrackedLink>
              <TrackedLink href="/guides-and-tutorials/notecard-guides/updating-esp32-host-firmware">
                Updating ESP32 Host Firmware
              </TrackedLink>
              <TrackedLink href="/guides-and-tutorials/notecard-guides/using-external-sim-cards">
                Using External SIM Cards
              </TrackedLink>
              <TrackedLink href="/guides-and-tutorials/notecard-guides/using-jsonata-to-transform-json">
                Using JSONata to Transform JSON
              </TrackedLink>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  </>
);

export default GuidesAndTutorials;
